// export const redeemInTime=
//  [
//     {
//         "aceLevel": "platinum+",
//         "reqPerDay": "2",
//         "maxAmount": "30000",
//     },
//     {
//         "aceLevel": "platinum",
//         "reqPerDay": "2",
//         "maxAmount": "30000",
//     },
//     {
//         "aceLevel": "gold",
//         "reqPerDay": "2",
//         "maxAmount": "15000",
//     },
//     {
//         "aceLevel": "silver",
//         "reqPerDay": "2",
//         "maxAmount": "5000",
//     },
//     {
//         "aceLevel": "bronze",
//         "reqPerDay": "2",
//         "maxAmount": "5000",
//     }
// ]

export const redeemInTime=
 [
    {
        "aceLevel": "platinum+",
        "reqPerDay": "30",
        "maxAmount": "20000",
    },
    {
        "aceLevel": "platinum",
        "reqPerDay": "30",
        "maxAmount": "20000",
    },
    {
        "aceLevel": "gold",
        "reqPerDay": "30",
        "maxAmount": "10000",
    },
    {
        "aceLevel": "silver",
        "reqPerDay": "30",
        "maxAmount": "5000",
    },
    {
        "aceLevel": "bronze",
        "reqPerDay": "30",
        "maxAmount": "5000",
    }
]